// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1_lhz","topSection":"styles_topSection__3CSIo","footerLinks":"styles_footerLinks__1byLx","footerCopyright":"styles_footerCopyright__3L9Ob"};